/**
 * Дельты макета. Направление намеренно инвертировано: рост числа жалоб —
 * красный `.up`, падение — зелёный `.down` (dashbdv3.html 1826–1838).
 * Значения абсолютные, не проценты (DECISIONS.md, 2026-09-07).
 */

interface DeltaProps {
    /** Уже посчитанная дельта: `count − prev_count`. */
    delta: number;
}

/** Крупная дельта `deltaHtml`. Оборачивать в `<span className="change">`. */
export function Delta({ delta }: DeltaProps) {
    if (delta > 0) return <span className="up">▲ +{delta}</span>;
    if (delta < 0) return <span className="down">▼ {delta}</span>;
    return <span className="flat">➡ 0</span>;
}

/** Компактная дельта `deltaSmall` — внутри `.value` или `.cat-num`. */
export function DeltaSmall({ delta }: DeltaProps) {
    if (delta > 0) return <span className="delta up">+{delta}</span>;
    if (delta < 0) return <span className="delta down">{delta}</span>;
    return <span className="delta flat">0</span>;
}

/** Бейдж приоритета: только для 1 и 2, для 3–5 бейджа нет. */
export function PriorityBadge({ priority }: { priority: number | null }) {
    if (priority === 1) return <span className="badge p1">П1</span>;
    if (priority === 2) return <span className="badge p2">П2</span>;
    return null;
}
